var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"product-price-display"},[_c('span',{staticClass:"dollar-sign"},[_vm._v("$")]),_vm._v("\n\t"+_vm._s(_vm.dollars)+"\n\t"),_c('visually-hidden',[_vm._v(".")]),_vm._v(" "),_c('span',{staticClass:"price-cents"},[_vm._v(_vm._s(_vm.cents))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }